import React from "react";
import { Link } from "react-router-dom";

const ProjectsCard = ({ project }) => {
  const { name, banner, description, liveSite, technologies, category, _id } =
    project;
  return (
    <div>
      <div className=" border-2 border-cardBorder shadow-md bg-card text-white hover:text-secondary">
        <img
          src={banner}
          alt=""
          className="object-cover object-center w-full h-72 bg-card"
        />
        <div className="flex flex-col justify-between p-6 space-y-8">
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <h2 className="text-3xl font-normal tracking-widest">{name}</h2>
              <p className="text-xs font-normal text-stone">{category}</p>
            </div>
            <p className="text-base leading-4 text-stone3 text-justify">
              {description.length > 100
                ? description.slice(0, 100) + "..."
                : description}
            </p>
            <ul className="flex flex-wrap gap-2 pt-2">
              {technologies.map((tech, i) => (
                <li
                  key={i}
                  className="text-xs leading-3 border bg-transparent px-2 py-1 rounded-md cardBtn"
                >
                  {tech}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <a
              href={liveSite}
              rel="noreferrer"
              target="_blank"
              className="px-3 font-semibold tracking-wide rounded-2xl bg-secondary text-white mr-3"
            >
              Site
            </a>
            <Link to={`/project/${_id}`}>
              <button
                type="button"
                className=" px-3 font-semibold tracking-wide rounded-2xl bg-secondary text-white"
              >
                Details
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;
